import { render, staticRenderFns } from "./NonCoreAutoOrderSettings.vue?vue&type=template&id=1ceb0a2c"
import script from "./NonCoreAutoOrderSettings.vue?vue&type=script&lang=js"
export * from "./NonCoreAutoOrderSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports